import React, { useRef, useEffect } from "react";
import HomeHeader from "share/organisms/headers/landing-header";
import Container from "share/atoms/container/";
import { useHistory } from "react-router-dom";
import { useScroll } from "share/hooks";
import styled from "styled-components";
import Exams from "./Exams";
import Explore from "./Explore";
import WhyChooseUs from "./WhyChooseUs";
import AvailablePlatforms from "./AvailablePlatforms";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import HeroScreen from "share/organisms/hero";
import Legacy from "./Legacy";
import Stats from "school-admin/Landing/Stats";
import { useScrollTo } from "share/hooks/useScrollTo";
import { SchoolLandingLayout } from "school-admin/Landing/styles";
import AwardCeremony from "containers/award-ceremony";
import Login from "student/Login";
import { useWindowSize } from "share/hooks";
import { getIsDeviceRestricted } from "./helper";
import DeviceNotSupport from "./DeviceNotSupport";
import { isMobile } from "react-device-detect";
import InfoIcon from "assets/ntat/icons/info.svg";
import { IoIosInformationCircle } from "react-icons/io";

function LandingHome(props) {
  return (
    <>
      <MobileExpWrapper>
        <IoIosInformationCircle size={20} />
        For better experience switch to desktop device.
      </MobileExpWrapper>
      <Login {...props} />
    </>
  );
}

export default LandingHome;

const MobileExpWrapper = styled.div`
  background-color: #f18235;
  padding: 10px 12px;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  display: none;
  @media screen and (max-width: 1240px) {
    display: flex;
  }
`;
